import { render, staticRenderFns } from "./GoToMasterExerciseItem.vue?vue&type=template&id=bd1425b0&lang=pug&"
import script from "./GoToMasterExerciseItem.vue?vue&type=script&lang=ts&"
export * from "./GoToMasterExerciseItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports